import { render, staticRenderFns } from "./RegisterNotFound.vue?vue&type=template&id=0f883601"
import script from "./RegisterNotFound.vue?vue&type=script&lang=js"
export * from "./RegisterNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports